import ProjectEditorStore from '@/TokamapEditor/stores/ProjectEditorStore';
import { action }         from 'mobx';
import { makeObservable } from 'mobx';
import { observable }     from 'mobx';

class CurrentProjectEditorStore {
	_store = new ProjectEditorStore('0');

	constructor() {
		makeObservable(this, {
			_store: observable,
			set: action,
		});
	}

	get get() {
		return this._store;
	}

	set(store: ProjectEditorStore) {
		this._store = store;
	}
}

export default new CurrentProjectEditorStore();